<div class="flex">
    <div class="m-r-3-s m-r-3-m m-r">
        <div class="pos-relative ratio-1-1 w-12"
             style="width: 126px;">
            <a [routerLink]="product?.data?.url">
                <img class="rf"
                     [image]="product?.data?.image">
            </a>

            @if (!isProductProtectionPlan) {
            <product-wishlist-toggle [productId]="product?.id"
                                     class="fs-5 pos-absolute z-4 top-1 left-1 basket-wishlist-icon">
            </product-wishlist-toggle>
            }
        </div>
    </div>

    <div class="flex-grow">
        <div class="p-l-3 p-b p-l-1-s p-l-1-m float-right flex">
            @if (isFreeGift) {
            <price class="col-1 block price"
                   sizeClass="SM: c1, XL: p1"
                   [value]="rowPrice"
                   [useFreeLabel]="true"></price>
            }
            @if (!isFreeGift) {
            @if (rowOrgPrice) {
            <price class="col-11 line-through m-r-2 block-s block-m"
                   sizeClass="SM: c1, XL: p1"
                   [value]="rowOrgPrice"></price>
            }
            <price class="col-1 block price"
                   sizeClass="SM: c1, XL: p1"
                   [value]="rowPrice"></price>
            }
        </div>


        <a class="w-9 w-10-m"
           [routerLink]="product?.data.url">
            @if (product?.displayBrandCode) {
            <p class="s1 col-11">{{asString(product.brandCode) | titlecase}}</p>
            }
            @if (product?.displayRangeCode) {
            <p class="s1">{{asString(product.rangeCode) | titlecase}}</p>
            }
            @if (product?.data?.product_outline) {
            <p class="p1">
                {{product.data?.product_outline}}</p>
            }
            @if (product?.data?.web_finish) {
            <p class="p1">{{product.data.web_finish}}</p>
            }
        </a>

        @if (!isProductProtectionPlan) {
        <basket-item-product-specification [product]="product"
                                           [attributes]="specificationAttributesCodes">
        </basket-item-product-specification>
        @if (stockDescription && !isGardenAssembly) {
        <p class="c1 col-11 m-t-2">{{stockDescription}}</p>
        }
        @if (product.data.short_description) {
        <ng-container *ngTemplateOutlet="productDataShortDescription"></ng-container>
        }
        @if (isEditable) {
        <div class="m-t-3 flex-s flex-m flex-justify-between flex-middle"
             style="width: 100%;">
            <basket-item-qty *ngIf="!isGardenAssembly"
                             [model]="data.qty"
                             [max]="maxQty > 9999 ? 9999 : maxQty"
                             [product]="product"
                             [status]="status"
                             class="inline-block va-m"
                             (qtyChange)="setQty($event)"></basket-item-qty>
            <action class="button-inline inline-block va-m"
                    [ngClass]="{'m-l' : !isGardenAssembly}"
                    sizeClass="SM: c1, XL: p2"
                    [status]="removeStatus"
                    (click)="remove()"
                    cy-basketRemove>{{'Remove' | translate}}</action>
        </div>
        }
        }
        @if (isProductProtectionPlan) {
        @if (product.data.short_description) {
        <ng-container *ngTemplateOutlet="productDataShortDescription"></ng-container>
        }
        @if (product.data.care_plan_features?.length) {
        <ul class="m-t-3 m-t-2-s m-b-1 m-b-3-s"
            sizeClass="XLM: protection-plan-ul">
            @for (item of product.data.care_plan_features; track item) {
            <li class="col-11 c1 m-b-2 m-b-0-s"><i class="icon-tick inline-block m-r-2 m-r-1-s col-3"></i>{{ item |
                optionLabel :
                'care_plan_features' }}
            </li>
            }
        </ul>
        }
        <div class="flex flex-justify-end-s"
             [ngClass]="{'p-t-1-x p-t-1-l': isProductProtectionPlan}">
            <action class="button-inline inline-block va-m"
                    sizeClass="SM: c1, XL: p2"
                    [status]="removeStatus"
                    (click)="remove()"
                    cy-basketRemove>{{'Remove' | translate}}</action>
        </div>
        }

        <result [status]="status"></result>
        <result [status]="removeStatus"></result>
    </div>
</div>

<ng-template #productDataShortDescription>
    <p class="c1 col-11 m-t-1 m-t-2-s">{{ product.data.short_description
        }} <button class="c1 col-1 button-inline button-inline-static-underline"
                type="button"
                [iCmsModalOpen]="'protectionPlanInfoModal'"
                [iCmsModalOpenData]="product"
                translate>
            Learn More
        </button></p>
</ng-template>
